// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"245":"component---src-pages-index-tsx","453":"component---src-pages-404-tsx"}[chunkId] + "-" + {"245":"de48726b279bf6ac01e0","453":"846411abb8a7486c66ab"}[chunkId] + ".js";
};